import React from 'react';
import { getDownloadAppQrImagePath } from '@/utils/appDownload';

type DownloadAppQrImageProps = {
  widthClassName?: string;
  className?: string;
};

/** 圆角需包一层 overflow-hidden，直接加在 img 上对部分 PNG 不生效 */
export default function DownloadAppQrImage({
  widthClassName = 'w-full',
  className = ''
}: DownloadAppQrImageProps) {
  return (
    <div
      className={`overflow-hidden rounded-[12px] ${widthClassName} ${className}`}
    >
      <img
        src={getDownloadAppQrImagePath()}
        alt=""
        className="block w-full h-auto"
      />
    </div>
  );
}
